<template>
  <img class="page-background" src="@/assets/undraw_welcoming.svg" />

  <div class="page-content" style="max-width: 400px">
    <h2 class="text-center mt-0">Choose a new password</h2>

    <p v-if="linkError" class="text-center text-danger">{{ linkError }}</p>

    <form v-else-if="ready" @submit.prevent="save">
      <InputText placeholder="New password" type="password" v-model="password" class="w-100 mb-3"
        autocomplete="new-password" name="password" />
      <InputText placeholder="Confirm password" type="password" v-model="passwordConfirm" class="w-100 mb-3"
        autocomplete="new-password" name="password-confirm" />
      <Button label="Update password" type="submit" class="w-100" :loading="loading" />
    </form>

    <p v-else class="text-center mb-0">Validating reset link…</p>
  </div>
</template>

<script>
import supabase from '@/services/supabase'

export default {
  data() {
    return {
      password: '',
      passwordConfirm: '',
      loading: false,
      ready: false,
      linkError: null,
      authSubscription: null,
      linkTimeout: null,
    }
  },
  async created() {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY' || event === 'SIGNED_IN') {
        this.ready = true
        this.linkError = null
        this.clearLinkTimeout()
      }
    })
    this.authSubscription = subscription

    const { data } = await supabase.auth.getSession()
    if (data.session) {
      this.ready = true
      return
    }

    this.linkTimeout = setTimeout(() => {
      if (!this.ready) {
        this.linkError = 'This reset link is invalid or has expired. Please request a new one.'
      }
    }, 8000)
  },
  beforeUnmount() {
    this.authSubscription?.unsubscribe()
    this.clearLinkTimeout()
  },
  methods: {
    clearLinkTimeout() {
      if (this.linkTimeout) {
        clearTimeout(this.linkTimeout)
        this.linkTimeout = null
      }
    },
    async save() {
      if (!this.password) {
        this.toastError('Please enter a new password')
        return
      }
      if (this.password !== this.passwordConfirm) {
        this.toastError('Passwords do not match')
        return
      }
      this.loading = true
      const { error } = await supabase.auth.updateUser({ password: this.password })
      this.loading = false
      if (error) {
        this.toastError(error)
        return
      }
      this.toastSuccess({}, 'Password updated. You can now sign in.')
      this.$router.push({ name: 'login' })
    },
  },
}
</script>

<style lang='scss' scoped></style>
